"use client";

import React from "react";
import { Check, ShoppingBag } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * CreateWebshop — Section 5: Pricing
 * Drop-in für: src/pages/CreateWebshop/sections/Preise.tsx
 *
 * Single-Pricing-Karte für Pro Webshop CHF 144 — als prominente Hero-Card,
 * nicht 2-Karten-Vergleich, weil Webshop ein eigenständiges Produkt ist.
 */

const features = ["Webshop-Erstellung durch PAGEMAKER24-Experte", "WooCommerce Backend auf WordPress", "Bis 50 Produkte einpflegen", "Twint &amp; Stripe Zahlungsanbindung", "Hosting auf Google Cloud + SSL", "MWST &amp; Rechnungs-Automatisierung", "Versand-Konfiguration nach Region", "5 Änderungen pro Jahr inklusive", "Persönlicher Schweizer Support"];
export default function Preise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-3xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Ein Paket. Alles drin.
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Klare Preise, kein Plugin-Overhead.
          </p>
        </div>

        <div className="relative bg-background border-2 border-primary rounded-2xl p-8 md:p-10 shadow-xl shadow-primary/10">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-white text-xs font-bold px-4 py-1 rounded-md shadow-md">
            Pro Webshop
          </span>

          <div className="text-center mb-8">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary mb-4">
              <ShoppingBag className="w-7 h-7" strokeWidth={1.5} />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Vollständiger Webshop
            </h3>
            <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto">
              Unser Team baut Ihren Schweizer Webshop — Sie liefern Produkte,
              wir liefern den Shop.
            </p>

            <div className="flex items-baseline justify-center gap-1 mb-1">
              <span className="text-5xl md:text-6xl font-bold text-foreground">
                CHF 144
              </span>
              <span className="text-xl text-muted-foreground">/ Monat</span>
            </div>
            <p className="text-xs text-muted-foreground">
              CHF 1'728 / Jahr · jährlich verrechnet
            </p>
          </div>

          <div className="border-t border-border pt-6 mb-8">
            <p className="text-[11px] font-semibold tracking-wider text-muted-foreground uppercase mb-4 text-center">
              Alles inklusive:
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-muted-foreground">
              {features.map((f, i) => <li key={i} className="flex items-start gap-2">
                  <Check className="w-4 h-4 text-green-500 mt-0.5 shrink-0" strokeWidth={2.5} />
                  <span dangerouslySetInnerHTML={{
                __html: f
              }} />
                </li>)}
            </ul>
          </div>

          <a href="https://dashboard.pagemaker24.ch/checkout?product_id=518&period=yearly" className="block text-center py-4 text-base font-bold rounded-lg bg-primary text-white shadow-lg shadow-primary/20 hover:opacity-90 hover:scale-[1.02] transition-all">
            Webshop bestellen
          </a>

          <p className="text-center text-xs text-muted-foreground mt-4">
            Setup-Zeit ca. 5 Werktage · Persönlicher Ansprechpartner inklusive
          </p>
        </div>
      </div>
    </section>;
}